<template>
  <ProSpaceSimpleGrid
    ref="businessKpiTable"
    tableClass="table-kpi"
    :headers="kpiTableHeader"
    :items="kpiCoverageItems"
    :deletable="false"
    :deleteMethod="null"
    :limit="null"
  />
</template>

<script>
import { ProSpaceSimpleGrid } from "@prospace/prospace-components-library";
import { useKpi } from "@composes/kpi";
export default {
  name: "TableKpiBusiness",
  components: {
    ProSpaceSimpleGrid,
  },
  props: {
    addressProgramOrder: {
        type: Object,
        required: true
    }
  },
  setup() {
    const { kpiTableHeader, setAddressProgramOrder, kpiCoverageItems } =
      useKpi();
    return {
      kpiTableHeader,
      setAddressProgramOrder,
      kpiCoverageItems,
    };
  },
  watch: {
    addressProgramOrder: {
        handler: function(value) {
            this.setAddressProgramOrder(value)
        },
        immediate: true
    }
  }
};
</script>
